/**
 * SDC_Modal - modal window custom plugin
 */
class SDC_Modal {
  constructor(element) {
    this.element = element;
    this.init();
  }

  // Props
  get props() {
    return {
      trigger: document.querySelector(`[data-modal-trigger="${this.element}"]`),
      modal: document.querySelector(`[data-modal="${this.element}"]`)
    }
  }

  // Init
  init() {
    this.openEvent();
    this.closeTrigger();
  }

  // Show Modal
  show() {
    // Hide modal window
    this.props.modal.classList.add('show');
    // Check if body already caontains 'open' class
    if (document.body.classList.contains('open')) return;
    // Remove vertical scroll
    document.body.classList.add('open', 'blur');
  }
  // Hide Modal
  hide() {
    // Show modal window
    this.props.modal.classList.remove('show');

    if (document.body.classList.contains('open')) document.body.classList.remove('open', 'blur')
  }

  // Open Modal Event
  openEvent() {
    this.props.trigger.addEventListener('click', () => this.show())
  }

  // Close Modal Event
  closeEvent(trigger) {
    trigger.addEventListener('click', () => this.hide());
  }

  // Close Triggers
  closeTrigger() {
    if (!this.props.modal) return
    // Collect close buttons
    let closeButtons = [
      ...this.props.modal.getElementsByClassName('modal-close'),
      document.querySelector('.sdc-overlay')
    ]

    closeButtons.forEach(closeButton => this.closeEvent(closeButton))
  }
}

class SDC_Modal_Carousel extends SDC_Modal {
  constructor(selector) {
    super(selector)
    this.modalCarousel = this.props.modal.querySelector('.sdc-missions-carousel')
    this.nextBtn = this.modalCarousel.querySelector('.sdc-missions-bttn__next')
  }

  show() {
    super.show()
    this.carouselMount()
  }

  carouselInst() {
    return new Glide(this.modalCarousel, {
      rewind: false,
    })
  }

  carouselMount() {
    let carousel = this.carouselInst()

    // Set default label to Next Button
    carousel.on('mount.after', () => {
      this.nextBtn.textContent = this.nextBtn.dataset.label
    })

    // Change Next Button label depense on current slide
    carousel.on(['mount.after', 'run.after'], () => {
      if (carousel.index + 1 === carousel._c.Sizes.length) {
        this.nextBtn.textContent = this.nextBtn.dataset.last
        this.nextBtn.classList.add('modal-close')

      } else {
        this.nextBtn.textContent = this.nextBtn.dataset.label
        this.nextBtn.classList.remove('modal-close')
      }
    })
    // Init carousel
    carousel.mount()
    // Call next slide method
    this.nextSlide(carousel)
  }

  // Move to next slide after Next Button click
  nextSlide(carousel) {
    this.nextBtn.addEventListener('click', () => {
      carousel.go('>');
      // If it the last slide close modal
      if (this.nextBtn.classList.contains('modal-close')) {
        this.hide()
      }
    })
  }

}


document.addEventListener('DOMContentLoaded', () => {
  // Get all modal triggers
  let triggers = document.querySelectorAll('.sdc-missions-trigger');
  if (!triggers) return
  triggers.forEach(trigger => {
    // Modal carousel instance
    new SDC_Modal_Carousel(trigger.dataset.modalTrigger)
  })

})
